import {
  ALargeSmall,
  ArrowLeft,
  ArrowRight,
  BookOpen,
  Check,
  ChevronLeft,
  ChevronRight,
  Copy,
  FilePenLine,
  History,
  LogOut,
  Menu,
  MessageSquarePlus,
  MessagesSquare,
  Pencil,
  PanelRight,
  Reply,
  RotateCcw,
  Save,
  Send,
  SunMoon,
  Trash2,
  X,
  createIcons,
} from "lucide";

const iconSet = {
  ALargeSmall,
  ArrowLeft,
  ArrowRight,
  BookOpen,
  Check,
  ChevronLeft,
  ChevronRight,
  Copy,
  FilePenLine,
  History,
  LogOut,
  Menu,
  MessageSquarePlus,
  MessagesSquare,
  Pencil,
  PanelRight,
  Reply,
  RotateCcw,
  Save,
  Send,
  SunMoon,
  Trash2,
  X,
};

function byId<T extends HTMLElement>(id: string): T {
  const element = document.getElementById(id);
  if (!element) throw new Error(`缺少页面元素 #${id}`);
  return element as T;
}

export const ui = {
  gate: byId<HTMLElement>("gate"),
  loginForm: byId<HTMLFormElement>("loginForm"),
  password: byId<HTMLInputElement>("password"),
  loginBtn: byId<HTMLButtonElement>("loginBtn"),
  loginError: byId<HTMLElement>("loginError"),
  app: byId<HTMLElement>("app"),
  sidebar: byId<HTMLElement>("sidebar"),
  navCloseBtn: byId<HTMLButtonElement>("navCloseBtn"),
  documentsNavBtn: byId<HTMLButtonElement>("documentsNavBtn"),
  boardNavBtn: byId<HTMLButtonElement>("boardNavBtn"),
  navOpenCount: byId<HTMLElement>("navOpenCount"),
  docNav: byId<HTMLElement>("docNav"),
  tocSection: byId<HTMLElement>("tocSection"),
  tocNav: byId<HTMLElement>("tocNav"),
  authorName: byId<HTMLInputElement>("authorName"),
  roleBadge: byId<HTMLElement>("roleBadge"),
  themeBtn: byId<HTMLButtonElement>("themeBtn"),
  logoutBtn: byId<HTMLButtonElement>("logoutBtn"),
  menuBtn: byId<HTMLButtonElement>("menuBtn"),
  viewKicker: byId<HTMLElement>("viewKicker"),
  viewTitle: byId<HTMLElement>("viewTitle"),
  wordCount: byId<HTMLElement>("wordCount"),
  readerStatus: byId<HTMLElement>("readerStatus"),
  progressText: byId<HTMLElement>("progressText"),
  progressBar: byId<HTMLElement>("progressBar"),
  readingProgress: document.querySelector<HTMLElement>(".reading-progress")!,
  fontScaleBtn: byId<HTMLButtonElement>("fontScaleBtn"),
  commentsBtn: byId<HTMLButtonElement>("commentsBtn"),
  docCommentBadge: byId<HTMLElement>("docCommentBadge"),
  documentView: byId<HTMLElement>("documentView"),
  reader: byId<HTMLElement>("reader"),
  docPager: byId<HTMLElement>("docPager"),
  editDocBtn: byId<HTMLButtonElement>("editDocBtn"),
  historyBtn: byId<HTMLButtonElement>("historyBtn"),
  editor: byId<HTMLElement>("editor"),
  editorStatus: byId<HTMLElement>("editorStatus"),
  editorDraftHint: byId<HTMLElement>("editorDraftHint"),
  editorNote: byId<HTMLInputElement>("editorNote"),
  editorSaveBtn: byId<HTMLButtonElement>("editorSaveBtn"),
  editorCancelBtn: byId<HTMLButtonElement>("editorCancelBtn"),
  editorDraftNotice: byId<HTMLElement>("editorDraftNotice"),
  editorDraftText: byId<HTMLElement>("editorDraftText"),
  editorDraftRestoreBtn: byId<HTMLButtonElement>("editorDraftRestoreBtn"),
  editorDraftDiscardBtn: byId<HTMLButtonElement>("editorDraftDiscardBtn"),
  editorConflict: byId<HTMLElement>("editorConflict"),
  conflictDiffBtn: byId<HTMLButtonElement>("conflictDiffBtn"),
  conflictCopyBtn: byId<HTMLButtonElement>("conflictCopyBtn"),
  conflictReloadBtn: byId<HTMLButtonElement>("conflictReloadBtn"),
  editorSurface: byId<HTMLElement>("editorSurface"),
  historyMask: byId<HTMLElement>("historyMask"),
  historyDialog: byId<HTMLElement>("historyDialog"),
  historyBackBtn: byId<HTMLButtonElement>("historyBackBtn"),
  historyCloseBtn: byId<HTMLButtonElement>("historyCloseBtn"),
  historyTitle: byId<HTMLElement>("historyTitle"),
  historyList: byId<HTMLElement>("historyList"),
  historyDiffLabel: byId<HTMLElement>("historyDiffLabel"),
  historyRestoreBtn: byId<HTMLButtonElement>("historyRestoreBtn"),
  historyDiff: byId<HTMLElement>("historyDiff"),
  historyStatus: byId<HTMLElement>("historyStatus"),
  commentsPanel: byId<HTMLElement>("commentsPanel"),
  commentsCloseBtn: byId<HTMLButtonElement>("commentsCloseBtn"),
  fullDocumentCommentBtn: byId<HTMLButtonElement>("fullDocumentCommentBtn"),
  docCommentFilters: byId<HTMLElement>("docCommentFilters"),
  docOpenCommentCount: byId<HTMLElement>("docOpenCommentCount"),
  docAllCommentCount: byId<HTMLElement>("docAllCommentCount"),
  docCommentCount: byId<HTMLElement>("docCommentCount"),
  docCommentList: byId<HTMLElement>("docCommentList"),
  boardView: byId<HTMLElement>("boardView"),
  newGeneralCommentBtn: byId<HTMLButtonElement>("newGeneralCommentBtn"),
  statusFilters: byId<HTMLElement>("statusFilters"),
  boardDocFilter: byId<HTMLSelectElement>("boardDocFilter"),
  boardCount: byId<HTMLElement>("boardCount"),
  boardList: byId<HTMLElement>("boardList"),
  pageScrim: byId<HTMLButtonElement>("pageScrim"),
  selectionAction: byId<HTMLElement>("selectionAction"),
  selectionCommentBtn: byId<HTMLButtonElement>("selectionCommentBtn"),
  selectionHint: byId<HTMLElement>("selectionHint"),
  modalMask: byId<HTMLElement>("modalMask"),
  modal: byId<HTMLElement>("modal"),
  modalKicker: byId<HTMLElement>("modalKicker"),
  modalTitle: byId<HTMLElement>("modalTitle"),
  modalCloseBtn: byId<HTMLButtonElement>("modalCloseBtn"),
  modalQuote: byId<HTMLElement>("modalQuote"),
  modalLabel: byId<HTMLLabelElement>("modalLabel"),
  modalBody: byId<HTMLTextAreaElement>("modalBody"),
  modalError: byId<HTMLElement>("modalError"),
  modalCancelBtn: byId<HTMLButtonElement>("modalCancelBtn"),
  modalSubmitBtn: byId<HTMLButtonElement>("modalSubmitBtn"),
  toastRegion: byId<HTMLElement>("toastRegion"),
};

export function renderIcons(): void {
  createIcons({ icons: iconSet });
}
